import { IQuery } from 'core-ts-types';
import { PriorityFeedCapabilityConfiguration } from '../../configuration';

class PriorityFeedController {
  constructor(
    private ngSchedulePriorityFeedQuery: IQuery,
    private ngStudyGroupsPriorityFeedQuery: IQuery,
    private ngHoldPriorityFeedQuery: IQuery,
    private ngToDoPriorityFeedQuery: IQuery,
    private ngConversationsPriorityFeedQuery: IQuery,
    private ngAppointmentPriorityFeedQuery: IQuery,
    private ngAppointmentRequestPriorityFeedQuery: IQuery,
    private ngEventPriorityFeedQuery: IQuery,
    private ngReminderPriorityFeedQuery: IQuery,
    private ngSurveyPriorityFeedQuery: IQuery,
    private ngPriorityFeedCapabilityConfiguration: PriorityFeedCapabilityConfiguration
  ) {}
}

export default PriorityFeedController;



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/views/priority_feed/priority_feed.ts